import React from 'react';
import styled from 'styled-components';

interface TimerProps {
  timeLeft: number;
  totalTime: number;
}

const TimerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
`;

const TimerDisplay = styled.div<{ $isLow: boolean }>`
  font-size: 2.5rem;
  font-weight: 700;
  color: ${({ $isLow, theme }) => ($isLow ? theme.colors.error : theme.colors.accent)};
  font-variant-numeric: tabular-nums;
  transition: color 0.3s ease;

  ${({ theme }) => theme.breakpoints.mobile} {
    font-size: 2rem;
  }
`;

const TimerBar = styled.div`
  width: 100%;
  height: 8px;
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  overflow: hidden;
`;

const TimerFill = styled.div<{ $percentage: number; $isLow: boolean }>`
  height: 100%;
  width: ${({ $percentage }) => $percentage}%;
  background: ${({ $isLow, theme }) =>
    $isLow
      ? `linear-gradient(90deg, ${theme.colors.error}, ${theme.colors.warning})`
      : `linear-gradient(90deg, ${theme.colors.primary}, ${theme.colors.accent})`
  };
  transition: width 0.1s linear, background 0.3s ease;
`;

const Timer: React.FC<TimerProps> = ({ timeLeft, totalTime }) => {
  const percentage = (timeLeft / totalTime) * 100;
  const isLow = timeLeft <= 5;

  return (
    <TimerContainer>
      <TimerDisplay $isLow={isLow}>
        {timeLeft}s
      </TimerDisplay>
      <TimerBar>
        <TimerFill $percentage={percentage} $isLow={isLow} />
      </TimerBar>
    </TimerContainer>
  );
};

export default Timer;
